import { AVAILABLE_SUPPORTED_CURRENCIES } from '@app/common/constants';
import { APP_PREFIX, BALANCES_PAGE } from '@app/routes/urls';
import { useNavigate } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import BillingOverviewTablesSection from './components/BillingOverviewTablesSection/BillingOverviewTablesSection';
import FinancialIncomeAndKpis from './components/FinancialIncomeAndKpis/FinancialIncomeAndKpis';

const BILLING_BALANCES_TABS = {
  CLIENT: 'client',
  CAREGIVER: 'caregiver',
} as const;

const BillingOverview = () => {
  const navigate = useNavigate();

  const handleViewAllClients = () => {
    navigate(`/${APP_PREFIX}/${BALANCES_PAGE}?tab=${BILLING_BALANCES_TABS.CLIENT}`);
  };

  const handleViewAllPartners = () => {
    navigate(`/${APP_PREFIX}/${BALANCES_PAGE}?tab=${BILLING_BALANCES_TABS.CAREGIVER}`);
  };

  return (
    <SimpleBar className="max-h-[calc(100vh-100px)]">
      <div className="w-full mx-auto w-full">
        <FinancialIncomeAndKpis />

        <section className="mt-8">
          <BillingOverviewTablesSection
            currency={AVAILABLE_SUPPORTED_CURRENCIES.EURO}
            onViewAllClients={handleViewAllClients}
            onViewAllPartners={handleViewAllPartners}
          />
        </section>

        <div className="h-24" aria-hidden />
      </div>
    </SimpleBar>
  );
};

export default BillingOverview;
